import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsappIcon from '@mui/icons-material/WhatsApp';
import * as React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import './index.scss';

export interface SocialProps {
  collegeCameraName: string;
  collegeSenateName: string;
  shareUrl: string;
}

export const Social: React.FC<SocialProps> = ({
  collegeCameraName,
  collegeSenateName,
  shareUrl,
}) => {
  const shareOptions = {
    title: `Il mio collegio è ${collegeCameraName} alla Camera e ${collegeSenateName} al Senato, e il tuo? Scopri quali sono i candidati per cui voterai alle #ElezioniPolitiche2022 il 25 settembre sul #TrovaCollegio di @You_Trend e @SkyTG24`,
    url: shareUrl,
  };

  return (
    <div className="Social">
      <span>Condividi:</span>
      <div className="Social__buttons">
        <WhatsappShareButton {...shareOptions}>
          <div className="Social__button Social__button__whatsapp">
            <WhatsappIcon className="Social__icon" />
          </div>
        </WhatsappShareButton>
        <FacebookShareButton {...shareOptions}>
          <div className="Social__button Social__button__facebook">
            <FacebookIcon className="Social__icon" />
          </div>
        </FacebookShareButton>
        <TwitterShareButton {...shareOptions}>
          <div className="Social__button Social__button__twitter">
            <TwitterIcon className="Social__icon" />
          </div>
        </TwitterShareButton>
      </div>
    </div>
  );
};
